/** Styl pro toolbar k tématu Erma */
export const ToolbarStyles = {
  background: '#f4f4f4',
  padding: '.571rem .6rem',
  borderColor: 'var(--erma-secondary-220)',
  borderRadius: 'var(--erma-border-radius-sm)',
  gap: '.6rem',
  extend: {
    display: 'block'
  },
  css: ({ dt }) => `
        div.p-toolbar{
          display:  ${dt('toolbar.display')};
        }`
};
